import { createStyles } from "antd-style";

const useStyle = createStyles(({ prefixCls, css }) => ({
    linearGradientButton: css`
        &.${prefixCls}-btn-primary:not([disabled]):not(.${prefixCls}-btn-dangerous) {
            > span {
                position: relative;
            }

            &::before {
                content: "";
                background: linear-gradient(135deg, #851426, #a0001f);
                position: absolute;
                inset: -1px;
                opacity: 1;
                transition: all 0.3s;
                border-radius: inherit;
            }

            &:hover::before {
                opacity: 1;
            }
        }
    `,
    linearGradientButton2: css`
        &.${prefixCls}-btn-default:not([disabled]):not(.${prefixCls}-btn-dangerous) {
            > span {
                position: relative;
            }

            &::before {
                content: "";
                background: linear-gradient(135deg, #e4c45c, #9f6e29);
                position: absolute;
                inset: -1px;
                opacity: 1;
                transition: all 0.3s;
                border-radius: inherit;
            }

            &:hover::before {
                opacity: 1;
            }

            &:hover {
                color: #000;
            }
        }
    `
}));

export default useStyle;
